import { render } from "./UserInfoHearder.vue?vue&type=template&id=78676020&scoped=true"
import script from "./UserInfoHearder.vue?vue&type=script&lang=js"
export * from "./UserInfoHearder.vue?vue&type=script&lang=js"

import "./UserInfoHearder.vue?vue&type=style&index=0&id=78676020&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-78676020"

export default script